import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {UpdateArchivableParams} from 'app-core/platform/archivable/CoreObjectArchiveConstants';
import {patchJSONPromise, postJSONPromise} from 'util/Net';

export const SAMPLE_TYPES_URL = '/sample-types/listing';

export interface CreateSampleTypeParams {
  name: string;
  label: string;
}

export interface CreateSampleTypeResponse {
  createdIds: Array<string>;
}

export function createSampleType(sampleType: CreateSampleTypeParams): Promise<CreateSampleTypeResponse> {
  const creates = [sampleType];
  return postJSONPromise({url: getApiBaseForObjectType(DomainGraphType.SAMPLE_TYPE), data: {creates}});
}

export interface UpdateSampleTypeParams extends UpdateArchivableParams {
  id: string;
}

export interface UpdateSampleTypeResponse {
  updatedIds: Array<string>;
}

export function updateSampleType(sampleType: UpdateSampleTypeParams): Promise<UpdateSampleTypeResponse> {
  const updates = [sampleType];
  return patchJSONPromise({url: getApiBaseForObjectType(DomainGraphType.SAMPLE_TYPE), data: {updates}});
}
